import { roundDecimals } from '@iotv/datamodel-core';
/**
 * @link https://community.powerbi.com/t5/Desktop/How-to-calculate-lat-long-distance/td-p/1488227#:~:text=You%20need%20Latitude%20and%20Longitude,is%20Earth%20radius%20in%20km.)
 * Get Distance between two position (Km's)
 */
export const getCoordinateDistance = (lat1, lat2, lng1, lng2) => {
    // convert to radians
    const radLat1 = Math.PI * (lat1 / 180);
    const radLng1 = Math.PI * (lng1 / 180);
    const radLat2 = Math.PI * (lat2 / 180);
    const radLng2 = Math.PI * (lng2 / 180);
    const distance = Math.round(Math.acos(Math.sin(radLat1) * Math.sin(radLat2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radLng2 - radLng1)) * 6371 * 100) / 100;
    return roundDecimals(distance, 2);
};
/**
 * @deprecated in favour of `toEsp()` from `@iotv/iotv-v3-types`
 *
 * @link https://hal.science/hal-03210318/document
 */
export const getESPCalculation = (rssi, snr) => {
    const latter = 10 * Math.log10(1 + Math.pow(10, 0.1 * snr));
    return rssi + snr - latter;
    // calculation through excel
    // let espHalf = Math.pow(rssi / 10, 10) / (1 + Math.pow(snr / 10, 10));
    // return 10 * Math.log10(Math.pow(rssi / 10, 10) - espHalf);
};
